import { Subject } from 'rxjs'
import { filter } from 'rxjs/operators'
import type { HotkeyConfig, HotkeyName } from './hotkey-config'
import { hotkeyMap } from './hotkey-config'

export class HotkeysService {
  private readonly fired$ = new Subject<HotkeyName>()

  constructor() {
    window.addEventListener('keydown', this.handleKeyDown)
  }

  on(name: HotkeyName) {
    return this.fired$.pipe(filter((n) => n === name))
  }

  private handleKeyDown = (e: KeyboardEvent) => {
    for (const [name, config] of Object.entries(hotkeyMap) as [HotkeyName, HotkeyConfig][]) {
      if (this.matches(e, config)) {
        e.preventDefault()
        this.fired$.next(name)
        return
      }
    }
  }

  private matches(e: KeyboardEvent, { key, modifier }: HotkeyConfig): boolean {
    if (e.key.toLowerCase() !== key.toLowerCase()) return false
    switch (modifier) {
      case 'ctrl':
        return e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey
      case 'meta':
        return e.metaKey && !e.ctrlKey && !e.shiftKey && !e.altKey
      case 'ctrl+meta':
        return (e.ctrlKey || e.metaKey) && !e.shiftKey && !e.altKey
      case 'shift':
        return e.shiftKey && !e.ctrlKey && !e.metaKey && !e.altKey
      case 'alt':
        return e.altKey && !e.ctrlKey && !e.metaKey && !e.shiftKey
      default:
        return !e.ctrlKey && !e.metaKey && !e.shiftKey && !e.altKey
    }
  }
}
